import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    container: {
        padding: '15px',
        marginTop: '20px'
    },
    title: {
        fontSize: '20px',
        marginBottom: '20px',
        color: Colors.DARK_BLUE
    },
    actionBtnsContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    actionBtn: {
        color: Colors.DARK_BLUE
    },
    cardContainer: {
        padding: '4px',
        background: Colors.GRAY_BACKGROUND
    }
}))

export default useStyles